import { abortable } from "@/utils/abortable"
import { retry } from "@/utils/retry"

// Safety ceiling for a finite snapshot read, including retries and body decoding.
// Streaming subscriptions and writes do not use this budget.
export const SESSION_READ_TIMEOUT_MS = 30_000

export async function readSessionSnapshot<T>(read: (signal: AbortSignal) => Promise<T>, parent?: AbortSignal): Promise<T> {
  const controller = new AbortController()
  const signal = parent ? AbortSignal.any([parent, controller.signal]) : controller.signal
  const timer = setTimeout(() => controller.abort(new DOMException("Session read timed out. Retry loading the chat.", "TimeoutError")), SESSION_READ_TIMEOUT_MS)
  try {
    signal.throwIfAborted()
    return await abortable(retry(() => abortable(read(signal), signal), { signal }), signal)
  } finally {
    clearTimeout(timer)
  }
}
